const deviceList = () => import('@/pages/device/index.vue');
const deviceForm = () => import('@/pages/device/form.vue');

export default [{
    path: '/device/list',
    component: deviceList,
    meta: [{
        name: '设备管理'
    },
    {
        name: '设备列表',
        activeRoute: '/device/list'
    }]
}, {
    path: '/device/form',
    component: deviceForm,
    meta: [{
        name: '设备管理'
    }, {
        name: '设备列表',
        url: '/device/list'
    }, {
        name: '添加/编辑',
        activeRoute: '/device/list'
    }]
}];